import { type ComponentPropsWithoutRef, type FC } from 'react'

import { cn } from '@/utils/tailwind.utils'

import { Button } from '../Button'

import { OverlayButtonVariant } from './overlay-button-variants'

type Props = ComponentPropsWithoutRef<typeof Button>

export const OverlayButton: FC<Props> = ({
  className,
  type = 'link',
  children,
  disabled = false,
  ...props
}) => {
  return (
    <Button
      {...props}
      type={type}
      disabled={disabled}
      className={cn([OverlayButtonVariant({ disabled }), className])}
    >
      {children}
    </Button>
  )
}
